import { FC, ReactEventHandler } from 'react'
import styles from './angle-arrow.module.scss'

export interface AngleLeftProps {
  className?: string
  disabled?: boolean
  direction?: 'left' | 'right'
  onClick?: ReactEventHandler
}

const AngleArrow: FC<AngleLeftProps> = ({ className, disabled, direction, onClick }: AngleLeftProps) => {
  return (
    <i
      className={[
        'h-32px w-32px',
        styles.AngleArrow,
        className || '',
        disabled ? styles['AngleArrow-disabled'] : '',
        direction ? styles[`AngleArrow-${direction}`] : '',
      ].join(' ')}
      onClick={onClick}
    ></i>
  )
}

export default AngleArrow
